import React, { useState } from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerDataImmo } from '../../../data/modules/logistic-header';
import { Box, Tab, Tabs } from '@mui/material';
import { useParams } from 'react-router';
import AccountingFuelValidate from './AccountingFuelValidate';
import IndemnityValidation from './IndemnityValidation';

const tabSx = {
  minHeight: { xs: 52, sm: 46 },
  borderRadius: '8px',
  color: '#526581',
  fontSize: { xs: '12px', sm: '14px' },
  fontWeight: 600,
  lineHeight: 1.3,
  letterSpacing: '0.1px',
  textTransform: 'none',
  transition: 'background-color 180ms ease, color 180ms ease, box-shadow 180ms ease',
  '&:hover': {
    backgroundColor: '#eaf2ff',
    color: '#1976d2',
  },
  '&.Mui-selected': {
    backgroundColor: '#1976d2',
    color: '#ffffff',
    boxShadow: '0 4px 10px rgba(25, 118, 210, 0.24)',
  },
  '&.Mui-focusVisible': {
    outline: '3px solid rgba(25, 118, 210, 0.25)',
    outlineOffset: '2px',
  },
};

const AccountingMissionValidate = () => {
  const { mission_planning_id, timesheet_id, agenda_id, provisional_fuel_id } = useParams();
   const [value, setValue] = useState('one');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <MainContainer {...headerDataImmo}>
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          p: 0.75,
          mb: 2,
          overflow: 'hidden',
          border: '1px solid #dce6f3',
          borderRadius: '10px',
          backgroundColor: '#f4f7fb',
          boxShadow: '0 3px 10px rgba(15, 23, 42, 0.06)',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          aria-label="Validation du carburant et des indemnités"
          sx={{
            minHeight: 46,
            '& .MuiTabs-flexContainer': { gap: 1 },
            '& .MuiTabs-indicator': { display: 'none' },
          }}
        >
          <Tab
            value="one"
            label="Carburants prévisionnels"
            wrapped
            sx={tabSx}
          />
          <Tab value="two" label="Indemnité prévisionnels" wrapped sx={tabSx} />
        </Tabs>
      </Box>

      {
        value === 'one' && <AccountingFuelValidate mission_planning_id={mission_planning_id} timesheet_id={timesheet_id} agenda_id={agenda_id} provisional_fuel_id={provisional_fuel_id} />
      }
      {
        value === 'two' && <IndemnityValidation mission_planning_id={mission_planning_id} timesheet_id={timesheet_id} agenda_id={agenda_id} />
      }
    </Box>

    </MainContainer>
  );
};

export default AccountingMissionValidate;
